<ng-container *ngIf="a==1" >
    <button  mat-button [color]="color" [type]="type" [disabled]="isSubmitting || disabled" appAutofocus>
        <div class="button-loader">
            <ng-content>
            </ng-content>
            <mat-spinner *ngIf="isSubmitting" [diameter]="24"></mat-spinner>
        </div>
    </button>
</ng-container>
